import { ISgSdkHandler, TriggerAction } from "./types";

declare const sdkHandler: ISgSdkHandler; 

export async function saveUserData(data: object): Promise<any> {
  try {
    return Promise.all(
      Object.entries(data).map(saveData),
    );
  } catch (e) {
    console.warn(e);
  }
}

function saveData([ key, value ]: [string, unknown]) {
  return new Promise<void>(resolve => {
    sdkHandler.trigger(TriggerAction.SAVE, {
      key,
      value,
      callback() {
        resolve();
      },
    });
  });
}
